import React from "react";
import Card from "../../components/Card";
import HomeText from "../../components/HomeText";
import "./style.css";

function Home() {
  return (
    <div id="home-div">
      <Card />
      <HomeText />
    </div>
  );
}

export default Home;
